/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import Rating from "@mui/material/Rating";
import { whiteColor } from "assets/jss/nextjs-material-kit-pro.js";

import { withStyles } from "tss-react/mui";

export default function ProductAvatar(props) {
  const { priceBand, dealsLocale } = props;

  const StyledRating = withStyles(Rating, (theme) => ({
    iconFilled: {
      backgroundColor: theme.palette.primary.main, // hardcoded for test...should be linked to darkCustomColor
      borderRadius: 2,
      color: whiteColor,
      opacity: 0.75,
    },
    icon: {
      margin: theme.spacing(0.25),
      padding: 1,

      "& svg": { fontSize: "1rem" },
    },
  }));

  const iconToUse =
    dealsLocale !== "en-gb" ? (
      <MonetizationOnIcon fontSize="small" />
    ) : (
      <CurrencyPoundIcon fontSize="small" />
    );
  return (
    <StyledRating
      size="small"
      name="read-only"
      value={parseInt(priceBand) / 2}
      precision={0.5}
      readOnly
      icon={iconToUse}
      emptyIcon={iconToUse}
    />
  );
}
